import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const subscriptionMobile = {
  id: 'subscription-mobile',
  componentType: 'subscriptionMobile',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionOrNewsletter({ options, viewport: 'mobile', component: 'subscription' }),
  component: ({
    promoBoxSettings, breakpoints, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'subscription-mobile',
    props: { promoBoxSettings, breakpoints, viewport: 'mobile' },
    defaultConfig: config.getSubscriptionConfig({ promoBoxSettings, breakpoints, viewport: 'mobile' }),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

const subscriptionDesktop = {
  id: 'subscription-desktop',
  componentType: 'subscriptionDesktop',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionOrNewsletter({ options, viewport: 'desktop', component: 'subscription' }),
  component: ({
    promoBoxSettings, breakpoints, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'subscription-desktop',
    props: { promoBoxSettings, breakpoints, viewport: 'desktop' },
    defaultConfig: config.getSubscriptionConfig({ promoBoxSettings, breakpoints, viewport: 'desktop' }),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

export default [
  subscriptionMobile,
  subscriptionDesktop,
];
